import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import { logOutThunk } from '../../redux/security/LogOut/logOutThunk';

const LogOut = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Button
      data-testid="logout-link"
      onClick={(e) => {
        dispatch(logOutThunk());
        e.preventDefault();
      }}
    >
      {t('logoutBtn')}
    </Button>
  );
};

export default LogOut;
